export default __webpack_public_path__ + "static/media/cut.9715add6.svg";